import * as React from 'react';
import { Auth } from '@shared/Auth';
import { LStorage } from '@shared/Storage';


export class IamGate extends React.Component<{
    children?: React.ReactNode
}> {
    render() {
        const token = Auth.getStoredToken();
        const iamNotEnabled = typeof LStorage.getItem('iamNotEnabled') === 'string';

        if (iamNotEnabled) {
            return <div className='text-center padded'>{__('js_admin.disabled.personal.data.privacy')}</div>;
        }

        if (!token || (Auth.isTokenExpired(token) && !token.refreshToken)) {
            return <div className='text-center padded'>{__('js_admin.login_again_to_access_this_page')}</div>;
        }

        return this.props.children;
    }
}
